import axios from "axios"; //引入axios
//下面这两个不一定需要引入，看你项目需要拦截的时候做什么操作，但是一般都需要引入store
import store from "@/store/index"; //引入store
import { message } from '@/utils/js/initVariable';
import noMessageList from './noMessagePort';
import isOfflineList from './isOfflinePort';

let instanceBaseUrl;
let instance = axios.create();
// http request 拦截器
instance.interceptors.request.use(
  (config) => {
    const url = config.url.replace('api/', '');
    const isOfflineFlag = isOfflineList.includes(url);
    if (isOfflineFlag && __IS__OFFLINE__) {
      const error = new Error('当前处于离线模式，无法发送请求');
      return Promise.reject(error);
    }


    if (!instanceBaseUrl) {
      instanceBaseUrl = store.getters['defaultRootURL'];
    }
    if (typeof config.data === 'string') {
      try {
        if (!JSON.parse(config.data)["requestFlag"]) {
          config.url = instanceBaseUrl + config.url;
        }
      } catch(e) {
        config.url = instanceBaseUrl + config.url;
      }
    } else if (typeof config.data === 'object') {
      if (config.data.constructor === FormData) {
        config.data.delete('randomNumber');
      }
      if (!config.data["requestFlag"]) {
        config.url = instanceBaseUrl + config.url;
      }
    }
    const token = localStorage.getItem("userToken");
    const checkToken = localStorage.getItem("checkToken");
    // console.log(token);
    // console.log(checkToken);
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers['Authorization'] = token; //请求头加上token
      config.headers['checkToken'] = checkToken; //请求头加上token
      config.headers['token'] = token; //请求头加上token
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// http response 拦截器
instance.interceptors.response.use(
  (response) => {
    // 接口获取成功后打印结果
    if (
      response.data.code === 1004
      || response.data.code === 200
      || response.status === 200
    ) {
      console.log('%cport: ' + instanceBaseUrl, 'color: red');
      console.log('%curl: ' + response.config.url.replace(instanceBaseUrl, ''), 'color: red');
      console.log('%cparam:', 'color: green', response.config.data);
      console.log('%cresult:', 'color: blue', response.data);
    }
    const startStr = '/api/',
      url = response.config.url.slice(
        response.config.url.indexOf(startStr) + startStr.length
      );
    const noMessageFlag = noMessageList.includes(url);
    if (
      response.data.code !== 1004
      && response.data.code !== 0
      && response.data.msg
      && !noMessageFlag
    ) {
      message(response.data.msg, 2);
    }
    // 退出登录
    if (response.data.code) {
      if ((
        (
          response.data.msg === '认证失败'
          &&
          (
            !response.config.url.includes('all/order/checkIsBuyRoiMeal.do')
            // || !response.config.url.includes('all/user/loginOut.do')
          )
        )
        ||
        response.data.code === 1002
      )) {
        loginOut();
        return;
      }
    }
    //拦截响应，做统一处理
    return response;
  },
  //接口错误状态处理，也就是说无响应时的处理
  (error) => {
    error.response && message(error.response.data.msg, 2);
    return Promise.reject(error); // 返回接口返回的错误信息
  }
);
function loginOut() {
  if (localStorage.getItem('isLogin')) {
    message('请重新登录', 2);
  }
  store.dispatch('loginOutNoCheck');
}

export default instance;